import React from "react"
import cls from "classnames"

import t from "@/constants/wording"

import * as styles from "./index.module.scss"
import { Icon } from "@/components"

type IProps = {
  tagsAndCount: { [key: string]: number }
  checkedTags: string[]
  checkHandle: (tag: string, isChecked: boolean) => void
  className?: string
}

const PracticeTagSelect: React.FC<IProps> = props => {
  const { tagsAndCount, checkedTags, checkHandle, className = null } = props
  const onCheck = (tag: string) => {
    if (checkedTags.length === 1 && checkedTags[0] === tag) {
      return
    }
    checkHandle(tag, !checkedTags.includes(tag))
  }
  return (
    <div className={cls(styles.tagContainer, className, "p-5")}>
      <div
        className={cls(
          styles.headerContainer,
          "pb-4 is-flex is-justify-content-space-between"
        )}
      >
        <h5>{t("select by tags")}</h5>
        <div className={styles.tipArea}>
          <span>{t("multi selectable")}</span>
        </div>
      </div>
      <ul className={styles.tagList}>
        {Object.entries(tagsAndCount).map((item, i) => {
          return (
            <li
              className="is-flex is-justify-content-space-between"
              key={item[0] + i}
              onClick={() => onCheck(item[0])}
            >
              <span className={styles.checkboxWrapper}>
                <span
                  className={
                    checkedTags.includes(item[0])
                      ? styles.iconChecked
                      : styles.iconNormal
                  }
                >
                  <Icon
                    name={
                      checkedTags.includes(item[0])
                        ? "checkbox-active"
                        : "checkbox-normal"
                    }
                  />
                </span>
                <label className="checkbox">{item[0]}</label>
              </span>
              <p>{item[1]}</p>
            </li>
          )
        })}
      </ul>
    </div>
  )
}

export default PracticeTagSelect
